module.exports = __webpack_public_path__ + "static/media/21Round.70812b6d.png";